import * as React from "react";
import Datetime from "react-datetime";
import * as moment from "moment";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { Dialog } from "../framework/dialog";
import { IEndlessList, EndlessList } from "ui/Scripts/source/models/common/endlessList";
import { SelectCompanyDialog, SelectCompanyDialogListLine } from "../framework/selectCompanyDialog";
import { IIdCodeNameLogo, IdCodeNameLogo } from "../../models/common/idCodeNameLogo";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

//MessageListSearchDialog
//***************************************************************
export interface IMessageListSearchDialogProp {
    classes?: string;
    startDate: number;
    endDate: number;
    companyId: string;
    companies: IIdCodeNameLogo[];
    onOk: (startDate: number, endDate: number, companyId: string) => void;
    onCancel: () => void;
}

export interface IMessageListSearchDialogState {
    companies: IIdCodeNameLogo[];
    startDate: string;
    endDate: string;
    companyId: string;
    showSelectCompanyDialog: boolean;
}

export class MessageListSearchDialog extends React.Component<IMessageListSearchDialogProp, IMessageListSearchDialogState> {
    private getCompanies(props: IMessageListSearchDialogProp): IIdCodeNameLogo[] {
        const result: IIdCodeNameLogo[] = [];
        const allUnit = new IdCodeNameLogo();
        allUnit.id = Base.emptyGuid;
        allUnit.name = "'" + Translations.All + "'";
        result.push(allUnit);
        for (let i = 0; i < props.companies.length; i++) {
            result.push(new IdCodeNameLogo(props.companies[i]));
        }
        return result;
    }

    private getCompanyById(companies: IIdCodeNameLogo[], companyId: string): IIdCodeNameLogo {
        let unit = companies.find(i => i.id === companyId);
        if (Base.isNullOrUndefined(unit)) {
            unit = companies[0];
        }
        return unit;
    }

    constructor(props) {
        super(props);
        this.state = {
            companies: this.getCompanies(props),
            startDate: Base.utcTimeToDateStr(props.startDate),
            endDate: Base.utcTimeToDateStr(props.endDate),
            companyId: props.companyId,
            showSelectCompanyDialog: false
        };
    }

    handleCompanyClick = (e) => {
        e.prmessageDefault();
        e.stopPropagation();
        this.setState({ showSelectCompanyDialog: true });
    };

    handleLoadCompanies = (page: number): Promise<IEndlessList<IIdCodeNameLogo>> => {
        return new Promise<IEndlessList<IIdCodeNameLogo>>((resolve, reject) => {
            const result = new EndlessList<IIdCodeNameLogo>(null, IdCodeNameLogo);
            result.items = this.state.companies;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleSelectCompanyDialogOk = (id: string, code: string) => {
        this.setState({
            companyId: id,
            showSelectCompanyDialog: false
        });
    };

    handleSelectCompanyDialogCancel = () => {
        this.setState({
            showSelectCompanyDialog: false
        });
    };

    handleStartDateChange = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                this.setState({ startDate: "" });
            }
        } else {
            this.setState({ startDate: Base.utcTimeToDateStr(value) });
        }
    };

    handleEndDateChange = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                this.setState({ endDate: "" });
            }
        } else {
            this.setState({ endDate: Base.utcTimeToDateStr(value) });
        }
    };

    handleStartDateBlur = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            this.setState({ startDate: Base.utcTimeToDateStr(value.toUtcDate().getTime()) });
        } else {
            this.setState({ startDate: Base.utcTimeToDateStr(value) });
        }
    };

    handleEndDateBlur = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            this.setState({ endDate: Base.utcTimeToDateStr(value.toUtcDate().getTime()) });
        } else {
            this.setState({ endDate: Base.utcTimeToDateStr(value) });
        }
    };

    handleOkClick = () => {
        this.props.onOk(!Base.isNullOrEmpty(this.state.startDate) ? this.state.startDate.toUtcDate().getTime() : null, !Base.isNullOrEmpty(this.state.endDate) ? this.state.endDate.toUtcDate().getTime() : null,
            !Base.isNullOrEmpty(this.state.companyId) && this.state.companyId !== Base.emptyGuid ? this.state.companyId : null);
    };

    handleCancelClick = () => {
        this.props.onCancel();
    };

    handleClearClick = () => {
        this.setState({ startDate: "", endDate: "", companyId: "" });
    };

    render() {
        const state = this.state;
        const company = this.getCompanyById(this.state.companies, state.companyId);

        const dialogClasses = "messageListSearchDialog" + (!Base.isNullOrEmpty(this.props.classes) ? " " + this.props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.SearchCurrentTopics}
                body={
                    <div>
                        {this.props.companies.length > 1 &&
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group roWhite">
                                        <label className="control-label">{Translations.Publisher}</label>
                                        <SelectCompanyDialogListLine
                                            classes={"form-control companyLine"}
                                            item={company}
                                            selected={false}
                                            onClick={(id: string) => { this.setState({ showSelectCompanyDialog: true }); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="control-label">{Translations.SearchStartDate}</label>
                                    <Datetime
                                        locale={appConfig.culture}
                                        className={"roWhite"}
                                        value={state.startDate}
                                        dateFormat={"D.M.YYYY"}
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        inputProps={{ maxLength: 10, readOnly: true, disabled: false }}
                                        onChange={this.handleStartDateChange}
                                        onBlur={this.handleStartDateBlur}
                                        renderInput={ (props) => {
                                            function clear() {
                                                props.onChange({ target: { value: "" } });
                                            }
                                            return (
                                                <div className="input-group">
                                                    <input {...props} />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-default" type="button" onClick={clear}>X</button>
                                                    </div>
                                                </div>
                                            );
                                        } }/>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label className="control-label">{Translations.SearchEndDate}</label>
                                    <Datetime
                                        locale={appConfig.culture}
                                        className={"roWhite right"}
                                        value={state.endDate}
                                        dateFormat={"D.M.YYYY"}
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        inputProps={{ maxLength: 10, readOnly: true, disabled: false }}
                                        onChange={this.handleEndDateChange}
                                        onBlur={this.handleEndDateBlur}
                                        renderInput={ (props) => {
                                            function clear() {
                                                props.onChange({ target: { value: "" } });
                                            }
                                            return (
                                                <div className="input-group">
                                                    <input {...props} />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-default" type="button" onClick={clear}>X</button>
                                                    </div>
                                                </div>
                                            );
                                        } }/>
                                </div>
                            </div>
                        </div>
                        {this.state.showSelectCompanyDialog &&
                            <SelectCompanyDialog
                                title={Translations.SelectCompany}
                                selectedId={state.companyId}
                                loadCompanies={this.handleLoadCompanies}
                                onOk={this.handleSelectCompanyDialogOk}
                                onCancel={this.handleSelectCompanyDialogCancel}
                            />
                        }
                    </div>
                }
                buttons={[
                    { title: Translations.Clear, buttonType: DialogButtonType.Default, classes: "mr-auto", onClick: this.handleClearClick },
                    { title: Translations.OK, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick },
                    { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }
                ]}
                onClose={this.handleCancelClick}/>
        );
    }
}